import React, { useState, useRef } from "react";
import { Dialog, Button, Grid } from "@material-ui/core";
import { Close, Print } from "@material-ui/icons";
import { CalculationPillBox } from "components/Calculators/TestHarness";
import PageWrapper from "components/Global/PageOrganization/PageWrapper";
import { useReactToPrint } from "react-to-print";

import { Template } from "../../pdf-export-templates";

import { THCashflowTable, ColorPickerSection } from "./";
import "./styles.css";

const TestHarnessCashflowModal = props => {
  const { handleClose, open, calculations } = props;
  const {
    costSavingsResult = 0,
    prepaymentPenalty = 100000,
    existingCashflows,
    pvCashflows,
    costSavings
  } = calculations || {};

  const [buttonSelected, setButtonSelected] = useState(0);
  const [showPdf, setShowPdf] = useState(false);
  const [primaryColor, setPrimaryColor] = useState("#005AA9");
  const [secondaryColor, setSecondaryColor] = useState("#0F9AD6");
  const [accentColor, setAccentColor] = useState("#0F9AD640");
  const pdfRef = useRef();

  const handlePrint = useReactToPrint({ content: () => pdfRef.current });
  const refiType = prepaymentPenalty - costSavingsResult > 0 ? "Refi Breakeven" : "Refi Analysis";

  const ActionButtonsSection = () => (
    <div className="test-harness-cashflow-modal-buttons-row-wrapper">
      <Button onClick={handleClose}>
        <Close className="test-harness-cashflow-modal-button-icon" />
        <div className="test-harness-cashflow-modal-button-text">Close Drawer</div>
      </Button>
      {
        showPdf &&
          <Button onClick={handlePrint}>
            <Print className="test-harness-cashflow-modal-button-icon" />
            <div className="test-harness-cashflow-modal-button-text">Print</div>
          </Button>
      }
    </div>
  );

  const CashflowTypeButtons = [
    {
      label: "Existing Financing",
      id: 0
    },
    {
      label: "New Financing",
      id: 1
    },
    {
      label: "Interest Savings",
      id: 2
    }
  ];

  const ButtonMenu = () => (
    <Grid container direction="row" xs={12} justify="space-between" alignContent="center">
      <Grid item xs={6}>
        <div className="test-harness-cashflow-modal-cashflow-buttons-wrapper">
          {
            CashflowTypeButtons.map(({ id, label }, index) => (
              <Button
                key={index}
                className={`test-harness-cashflow-modal-cashflow-buttons ${buttonSelected === id ? "selected" : ""}`}
                onClick={() => {
                  setButtonSelected(id);
                }}
              >
                {label}
              </Button>
            ))
          }
        </div>
      </Grid>
      <Grid item xs={4} />
      <Grid container item xs={2} justify="flex-end" alignContent="center"><Button className="test-harness-cashflow-modal-cashflow-buttons selected" onClick={() => setShowPdf(true)}>Export to PDF</Button></Grid>
    </Grid>
  );

  const getRowsForTable = () => {
    switch (buttonSelected) {
      case 0:
        return existingCashflows;
      case 1:
        return pvCashflows;
      case 2:
        return costSavings;
    }
  };

  const colorOptions = [
    {
      color: primaryColor,
      onChange: setPrimaryColor,
      text: "Primary"
    },
    {
      color: secondaryColor,
      onChange: setSecondaryColor,
      text: "Secondary"
    },
    {
      color: accentColor,
      onChange: setAccentColor,
      text: "Accent"
    }
  ];

  return (
    <Dialog fullScreen open={open}>
      <ActionButtonsSection />
      <ColorPickerSection
        options={colorOptions}
        isVisible={showPdf}
      />
      <div className="test-harness-cashflow-modal-content-wrapper">
        {
          showPdf &&
            <Grid container>
              <Grid xs={12}>
                <div ref={pdfRef}>
                  <Template
                    {...props}
                    calculations={calculations}
                    refiType={refiType}
                    companyPrimaryColor={primaryColor}
                    companySecondaryColor={secondaryColor}
                    companyAccentColor={accentColor}
                  />
                </div>
              </Grid>
            </Grid>
        }
        {!showPdf && <PageWrapper>
          <Grid container direction="column" style={{ maxWidth: "1300px" }}>
            <Grid item>
              <Grid container alignItems="center"><CalculationPillBox calculations={calculations} /></Grid>
            </Grid>
            <Grid item><ButtonMenu /></Grid>
            <Grid item><THCashflowTable selection={buttonSelected} rows={getRowsForTable()} /></Grid>
          </Grid>
                     </PageWrapper>}
      </div>
    </Dialog>
  );
};

export default TestHarnessCashflowModal;
